import { Button } from '@/components/shadcn/button'
import { SectionContainer } from '@/pages/shared-components/SectionContainer'
import { IconArrowLeftOutline } from '@icons/IconArrowLeftOutline'
import { SyncImportForm } from './SyncImportForm'

export function SyncImportSection({ reset, file }: { reset: () => void; file: File }) {
  if (!file) return null
  return (
    <SectionContainer
      title="Select import options"
      action={
        <Button variant="outline" size="sm" onClick={reset}>
          <IconArrowLeftOutline className="mr-2" />
          <span>Go Back</span>
        </Button>
      }
    >
      <SyncImportForm file={file} />
    </SectionContainer>
  )
}
